import axios from "axios";

const endpoint = process.env.REACT_APP_API_URL;

export const FETCH_COMPANY_BEGIN = "FETCH_COMPANY_BEGIN";
export const FETCH_COMPANY_SUCCESS = "FETCH_COMPANY_SUCCESS";
export const FETCH_COMPANY_FAILURE = "FETCH_COMPANY_FAILURE";

export const fetchCompanyBegin = () => ({
  type: FETCH_COMPANY_BEGIN,
});

export const fetchCompanySuccess = (company) => ({
  type: FETCH_COMPANY_SUCCESS,
  payload: company,
});

export const fetchCompanyFailure = (error) => ({
  type: FETCH_COMPANY_FAILURE,
  payload: { error },
});

export async function getCompany(id) {
  return async (dispatch) => {
    dispatch(fetchCompanyBegin());
    try {
      const { data } = await axios.get(`${endpoint}/companies/${id}`);
      dispatch(fetchCompanySuccess(data));
    } catch (err) {
      dispatch(fetchCompanyFailure(err));
    }
  };
}

export const createCompany = async (company) => {
  const created = await axios.post(`${endpoint}/companies`, company);

  if (created.status !== 200) {
    throw new Error("Failed to create company");
  }
  return created;
};

export const updateCompany = async (id, update) => {
  const config = {
    headers: {
      "content-type": "multipart/form-data"
    },
  };
  const formData = new FormData();
  Object.keys(update).forEach(key => formData.append(key, update[key]));
  const updated = await axios.patch(`${endpoint}/companies/${id}`, formData, config);

  if (updated.status !== 200) {
    throw new Error("Failed to update company");
  }
  return updated;
};
